module.exports = __webpack_public_path__ + "img/dp-ld-sy2.6c65c102.png";